import React, { useState } from "react";
import { Modal, Row, Col, Table } from "react-bootstrap";
import GolbalSearch from "../utils/GolbalSearch";

const BidHistoryModal = ({ 
  show, 
  onHide, 
  selectedCustomerHistory, 
  historyRowData, 
  historyColumns 
}) => {
  const [globalSearchText, setGlobalSearchText] = useState("");

  const handleGlobalSearch = (searchText) => {
    setGlobalSearchText(searchText);
  };

  const filteredData = historyRowData.filter(row =>
    !globalSearchText ||
    Object.values(row).some(val =>
      val && val.toString().toLowerCase().includes(globalSearchText.toLowerCase())
    )
  );

  return (
    <Modal show={show} onHide={onHide} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>
          {selectedCustomerHistory ?
            `Bid History - ${selectedCustomerHistory.CustomerName || selectedCustomerHistory.CustomerUserName}` :
            "Global Bid History"
          }
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="global-search-container">
          <Row>
            <Col></Col>
            <Col>
              <GolbalSearch filterFunc={handleGlobalSearch} />
            </Col>
          </Row>
        </div>
        <Table bordered size="sm" responsive>
          <thead style={{ backgroundColor: '#F1F1ED' }}>
            <tr>
              <th style={{ backgroundColor: '#F1F1ED', fontWeight: 'bold' }}>BP Code</th>
              <th style={{ backgroundColor: '#F1F1ED', fontWeight: 'bold' }}>BP Name</th>
              <th style={{ backgroundColor: '#F1F1ED', fontWeight: 'bold' }}>User ID/Name</th>
              <th style={{ backgroundColor: '#F1F1ED', fontWeight: 'bold' }}>Email ID</th>
              <th style={{ backgroundColor: '#F1F1ED', fontWeight: 'bold' }}>Bid Submission Date Time</th>
              <th style={{ backgroundColor: '#F1F1ED', fontWeight: 'bold' }}>Price (₹)</th>
            </tr>
          </thead>
          <tbody>
            {filteredData.length > 0 ? (
              filteredData.map((row, index) => (
                <tr key={index}>
                  <td>{row.BPCode}</td>
                  <td>{row.BPName}</td>
                  <td>{row.UserIdName}</td>
                  <td>{row.EmailId}</td>
                  <td>{row.BidSubmissionDateTime}</td>
                  <td>{row.Price}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6" className="text-center">No history data available</td>
              </tr>
            )}
          </tbody>
        </Table>
      </Modal.Body>
    </Modal>
  );
};

export default BidHistoryModal;